import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { CtaButton } from './CtaButton';
import { heroBenefits, IMAGES } from '../data/content';
const EASE = [0.23, 1, 0.32, 1] as const;
export function HeroSection() {
  return <section className="relative overflow-hidden bg-industrial px-5 pb-12 pt-7 sm:px-8 lg:pb-16 lg:pt-12" data-id="element-65" data-mp="23wmgr3djzbgl">
      <div aria-hidden="true" className="pointer-events-none absolute inset-0 opacity-[0.06]" style={{
      backgroundImage: 'linear-gradient(to right, #F8FAFC 1px, transparent 1px), linear-gradient(to bottom, #F8FAFC 1px, transparent 1px)',
      backgroundSize: '64px 64px'
    }} data-id="element-66" data-mp="28ueggjkfw1vc" />

      <div className="relative mx-auto max-w-6xl lg:grid lg:grid-cols-[1.05fr_0.95fr] lg:items-center lg:gap-x-12" data-id="element-67" data-mp="2rsqtigeh1vw7">
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        ease: EASE
      }} data-id="element-68" data-mp="3fibaitr2ej2u">
          <span className="inline-flex items-center gap-1.5 rounded-full border border-electrico/60 bg-electrico/10 px-3 py-1.5 text-[0.65rem] font-bold uppercase tracking-wider text-electrico-light sm:text-xs" data-id="element-69" data-mp="2ffibjshql5pi">
            🔨 Carpintería en aluminio • Desde cero
          </span>

          <h1 className="mt-4 font-display text-[1.75rem] font-black uppercase leading-[1.1] text-crudo sm:text-[2.6rem] lg:text-[3rem]" data-id="element-70" data-mp="2p7ena6cqwuc7">
            Aprendé a fabricar{' '}
            <span className="text-electrico-light" data-id="element-71" data-mp="2z1y59aitlxs3">aberturas de aluminio</span>{' '}
            paso a paso
          </h1>

          <p className="mt-4 max-w-xl text-sm leading-relaxed text-aluminio sm:text-base" data-id="element-72" data-mp="2u6itqp8acdyu">
            Aprendé a medir, calcular, cortar, fabricar, presupuestar e instalar
            aberturas de aluminio con un sistema práctico y ordenado.
          </p>

          <ul className="mt-6 grid gap-2 sm:grid-cols-2" data-id="element-73" data-mp="1dr7sdl3gvsnn">
            {heroBenefits.map(benefit => <li key={benefit} className="flex items-center gap-2 text-sm font-semibold text-crudo" data-id="element-74" data-mp="18sdd2t4pkm8a">
                <CheckIcon className="h-4 w-4 shrink-0 text-verde-light" aria-hidden="true" data-id="element-75" data-mp="3dsefrd044ewh" />
                {benefit}
              </li>)}
          </ul>
        </motion.div>

        {/* Mockup */}
        <motion.div initial={{
        opacity: 0,
        scale: 0.97
      }} animate={{
        opacity: 1,
        scale: 1
      }} transition={{
        duration: 0.4,
        delay: 0.08,
        ease: EASE
      }} className="mt-8 lg:col-start-2 lg:row-span-2 lg:row-start-1 lg:mt-0" data-id="element-76" data-mp="3munmrsw69q54">
          <img src={IMAGES.heroMockup} alt="Super Combo Carpintería en Aluminio: los 6 tomos y los 6 bonos digitales" className="w-full rounded-2xl border border-crudo/10 shadow-2xl" loading="eager" data-id="element-77" data-mp="5ccll41u3u36" />
        </motion.div>

        {/* Scroll CTA — never a checkout on the first screen */}
        <motion.div initial={{
        opacity: 0,
        y: 16
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4,
        delay: 0.14,
        ease: EASE
      }} className="mt-8 lg:col-start-1 lg:row-start-2 lg:mt-9" data-id="element-78" data-mp="jaay03wlhgg1">
          <div className="sm:max-w-sm" data-id="element-79" data-mp="1ut87b2q20fwh">
            <CtaButton href="#incluye" label="Ver todo lo que incluye" size="lg" variant="scroll" data-id="element-80" data-mp="1uu00y803c3k4" />
          </div>
          <p className="mt-4 text-[0.7rem] font-semibold uppercase tracking-wider text-aluminio/60 sm:text-xs" data-id="element-81" data-mp="2mjmdsdvqmpy4">
            📚 Formación práctica • 📱 100% digital
          </p>
        </motion.div>
      </div>
    </section>;
}